import { render, staticRenderFns } from "./ClinicShortVideoCard.vue?vue&type=template&id=37f68368&scoped=true"
import script from "./ClinicShortVideoCard.vue?vue&type=script&lang=js"
export * from "./ClinicShortVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ClinicShortVideoCard.vue?vue&type=style&index=0&id=37f68368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f68368",
  null
  
)

export default component.exports